import React, { Fragment, useEffect, useState } from 'react'

import './InformeStockBalance.css'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faFileImport,
    faCalendarAlt,
    faBuilding,
    faFileExcel,
    faSearch,
    faChartBar,
    faLayerGroup,
} from '@fortawesome/free-solid-svg-icons'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import Header from '../Header/Header'

// route
import { withRouter } from 'react-router-dom'

// services
import { getAllSucursales } from '../../Services/sucursalService'
import { getReporteStockBalance } from '../../Services/informesService'
import { getExcelReporteStockBalance } from '../../Services/reporteService'

// utils
import { formatFechaArgentina } from '../../utils/fechaArgentina'

// alert swal
import Swal from 'sweetalert2'

const articleLabel = (fila) => {
    const codigo = fila.codigo != null ? String(fila.codigo).trim() : ''
    const nombre = fila.nombre != null ? String(fila.nombre).trim() : ''
    return [codigo, nombre].filter(Boolean).join(' - ')
}

const InformeStockBalance = ({ history }) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    let rol = token.authorities[0]

    const FormatDate = (date) => {
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()

        if (month < 10) month = '0' + month
        if (day < 10) day = '0' + day

        return year + '-' + month + '-' + day
    }

    const [isLoad, setIsLoad] = useState(true)
    const [sucursales, setSucursales] = useState([])
    const [sucursal, setSucursal] = useState(token.sucursal.id)
    const [fechaDesde, setFechaDesde] = useState(FormatDate(new Date()))
    const [fechaHasta, setFechaHasta] = useState(FormatDate(new Date()))
    const [granularidad, setGranularidad] = useState('MONTH')
    const [nombre, setNombre] = useState('')
    const [periodos, setPeriodos] = useState([])
    const [filas, setFilas] = useState([])
    const [hasGenerated, setHasGenerated] = useState(false)

    useEffect(() => {
        if (rol !== 'ROLE_ADMIN') history.goBack()
        if (isLoad) {
            getAllSucursales(true, 0, '', 1000)
                .then((res) => {
                    setSucursales(res.data.content)
                })
                .catch((error) => {
                    console.log(error)
                })
            setIsLoad(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoad])

    const nombreFilter = () => {
        const trimmed = nombre ? nombre.trim() : ''
        return trimmed ? trimmed : undefined
    }

    const requireFilters = () => {
        if (!fechaDesde || !fechaHasta || !sucursal || !granularidad) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'Desde, hasta, sucursal y granularidad son obligatorios',
                type: 'warning',
                showConfirmButton: false,
                timer: 1800,
            })
            return false
        }
        return true
    }

    const handleGenerarInforme = async () => {
        if (!requireFilters()) return

        try {
            const res = await getReporteStockBalance(
                fechaDesde,
                fechaHasta,
                sucursal,
                granularidad,
                nombreFilter()
            )
            const data = res.data || {}
            setPeriodos(data.periodos || [])
            setFilas(data.filas || [])
            setHasGenerated(true)
        } catch (error) {
            setHasGenerated(false)
            setPeriodos([])
            setFilas([])
            const apiMessage =
                (error.response &&
                    error.response.data &&
                    (error.response.data.mensaje ||
                        error.response.data.message)) ||
                'No se pudo cargar el balance de stock'
            Swal.fire({
                toast: true,
                position: 'top',
                title: apiMessage,
                type: 'info',
                showConfirmButton: false,
                timer: 1800,
            })
        }
    }

    const handleExcelReporte = async () => {
        if (!requireFilters()) return
        if (!filas.length) return

        try {
            const excel = await getExcelReporteStockBalance(
                periodos,
                filas,
                null
            )

            const contenido = encodeURI(excel.data)
            let excelWindow = window.open('')
            excelWindow.document.write(
                `<iframe width='100%' height='100%' margin='0px' padding='0px' src='data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${contenido}'>
                </iframe>`
            )
            setTimeout(() => {
                excelWindow.close()
            }, 3000)
        } catch (error) {
            Swal.fire({
                title: 'No hay datos para estas fechas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
        }
    }

    const sucursalNombre = () => {
        const found = sucursales.find(
            (s) => String(s.id) === String(sucursal)
        )
        return found ? found.nombre : sucursal
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo
                        icon={faFileImport}
                        title={'Informes Stock'}
                    />
                </div>

                <div className="bg-gris p-3">
                    <div className="d-flex bd-highlight mb-3 flex-wrap">
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputFechaDesde">Desde *</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                </span>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="inputFechaDesde"
                                    name="fechaDesde"
                                    value={fechaDesde}
                                    onChange={(e) =>
                                        setFechaDesde(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputFechaHasta">Hasta *</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                </span>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="inputFechaHasta"
                                    value={fechaHasta}
                                    name="fechaHasta"
                                    onChange={(e) =>
                                        setFechaHasta(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputSucursal">Sucursal *</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faBuilding} />
                                </span>
                                <select
                                    id="inputSucursal"
                                    className="custom-select"
                                    name="sucursal"
                                    value={sucursal}
                                    onChange={(e) =>
                                        setSucursal(e.target.value)
                                    }
                                >
                                    {sucursales.map((s, index) => (
                                        <option key={index} value={s.id}>
                                            {s.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputGranularidad">
                                Granularidad *
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faLayerGroup} />
                                </span>
                                <select
                                    id="inputGranularidad"
                                    className="custom-select"
                                    name="granularidad"
                                    value={granularidad}
                                    onChange={(e) =>
                                        setGranularidad(e.target.value)
                                    }
                                >
                                    <option value="MONTH">Mensual</option>
                                    <option value="WEEK">Semanal</option>
                                </select>
                            </div>
                        </div>
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputNombre">Nombre</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faSearch} />
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inputNombre"
                                    name="nombre"
                                    placeholder="Buscar por nombre"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                />
                            </div>
                        </div>
                        <div
                            className="ms-auto p-2 bd-highlight"
                            style={{ marginTop: 20 }}
                        >
                            <button
                                className="btn btn-outline-info btn-lg mr-2"
                                onClick={handleGenerarInforme}
                            >
                                <FontAwesomeIcon icon={faChartBar} /> Generar
                                Reporte
                            </button>
                            <button
                                className="btn btn-outline-success btn-lg"
                                onClick={handleExcelReporte}
                                disabled={!hasGenerated || filas.length === 0}
                                title={
                                    !hasGenerated
                                        ? 'Generá el reporte primero'
                                        : filas.length === 0
                                          ? 'Sin datos para exportar'
                                          : 'Exportar Excel'
                                }
                            >
                                <FontAwesomeIcon icon={faFileExcel} /> Excel
                            </button>
                        </div>
                    </div>
                    {hasGenerated && (
                        <p className="mb-0 text-muted">
                            Período:{' '}
                            {formatFechaArgentina(fechaDesde)} —{' '}
                            {formatFechaArgentina(fechaHasta)} · Sucursal:{' '}
                            {sucursalNombre()} · Granularidad:{' '}
                            {granularidad === 'WEEK' ? 'Semanal' : 'Mensual'}
                        </p>
                    )}
                </div>

                {hasGenerated && (
                    <Fragment>
                        <br />
                        <div className="bg-gris p-3">
                            <h5 className="mb-3">Balance de stock</h5>
                            <div className="informe-stock-balance-table-wrap">
                                <table className="table table-striped mt-3 text-center informe-stock-balance-table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Artículo</th>
                                            {periodos.map((periodo) => (
                                                <th
                                                    key={periodo.clave}
                                                    scope="col"
                                                >
                                                    {periodo.etiqueta}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filas.length === 0 ? (
                                            <tr>
                                                <td
                                                    colSpan={
                                                        Math.max(
                                                            periodos.length,
                                                            0
                                                        ) + 1
                                                    }
                                                >
                                                    Sin artículos para los
                                                    filtros seleccionados
                                                </td>
                                            </tr>
                                        ) : (
                                            filas.map((fila) => (
                                                <tr key={fila.articuloId}>
                                                    <td>
                                                        {articleLabel(fila)}
                                                    </td>
                                                    {(fila.cantidades || []).map(
                                                        (cantidad, index) => (
                                                            <td
                                                                key={`${fila.articuloId}-${index}`}
                                                            >
                                                                {cantidad}
                                                            </td>
                                                        )
                                                    )}
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Fragment>
                )}
            </div>
        </Fragment>
    )
}

export default withRouter(InformeStockBalance)
